// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file client/trading.proto (package client, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../buf/validate/validate_pb";
import type { AccountType } from "../common/billing_pb";
import { file_common_billing } from "../common/billing_pb";
import type { Pagination, SortDirection } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { AssetType, BetLifecycle, BetMessage, BetMessageSchema, BetOutcome, BetStatsMessageSchema, BetTimeMode, BetType, PairMessage } from "../common/trading_pb";
import { file_common_trading } from "../common/trading_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file client/trading.proto.
 */
export const file_client_trading: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_common_billing, file_common_common, file_common_trading, file_google_protobuf_empty]);

/**
 * @generated from message client.CancelBetRequest
 */
export type CancelBetRequest = Message<"client.CancelBetRequest"> & {
  /**
   * @generated from field: string bet_id = 1;
   */
  betId: string;
};

/**
 * Describes the message client.CancelBetRequest.
 * Use `create(CancelBetRequestSchema)` to create a new message.
 */
export const CancelBetRequestSchema: GenMessage<CancelBetRequest> = /*@__PURE__*/
  messageDesc(file_client_trading, 0);

/**
 * @generated from message client.ListTradingPairsRequest
 */
export type ListTradingPairsRequest = Message<"client.ListTradingPairsRequest"> & {
  /**
   * @generated from field: optional bool is_trading_enabled = 1;
   */
  isTradingEnabled?: boolean;

  /**
   * @generated from field: optional bool is_streaming = 2;
   */
  isStreaming?: boolean;

  /**
   * @generated from field: optional common.AssetType type = 3;
   */
  type?: AssetType;

  /**
   * @generated from field: optional string search = 4;
   */
  search?: string;

  /**
   * @generated from field: optional string sort_by = 5;
   */
  sortBy?: string;

  /**
   * @generated from field: common.SortDirection sort_dir = 6;
   */
  sortDir: SortDirection;

  /**
   * @generated from field: optional common.Pagination pagination = 7;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListTradingPairsRequest.
 * Use `create(ListTradingPairsRequestSchema)` to create a new message.
 */
export const ListTradingPairsRequestSchema: GenMessage<ListTradingPairsRequest> = /*@__PURE__*/
  messageDesc(file_client_trading, 1);

/**
 * @generated from message client.ListTradingPairsResponse
 */
export type ListTradingPairsResponse = Message<"client.ListTradingPairsResponse"> & {
  /**
   * @generated from field: repeated common.PairMessage data = 1;
   */
  data: PairMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListTradingPairsResponse.
 * Use `create(ListTradingPairsResponseSchema)` to create a new message.
 */
export const ListTradingPairsResponseSchema: GenMessage<ListTradingPairsResponse> = /*@__PURE__*/
  messageDesc(file_client_trading, 2);

/**
 * @generated from message client.ListBetsRequest
 */
export type ListBetsRequest = Message<"client.ListBetsRequest"> & {
  /**
   * @generated from field: repeated common.BetLifecycle lifecycle = 1;
   */
  lifecycle: BetLifecycle[];

  /**
   * @generated from field: optional common.AccountType account_type = 2;
   */
  accountType?: AccountType;

  /**
   * @generated from field: optional string pair_id = 3;
   */
  pairId?: string;

  /**
   * @generated from field: optional common.AssetType pair_type = 4;
   */
  pairType?: AssetType;

  /**
   * @generated from field: repeated common.BetType bet_type = 5;
   */
  betType: BetType[];

  /**
   * @generated from field: repeated common.BetOutcome outcome = 6;
   */
  outcome: BetOutcome[];

  /**
   * @generated from field: optional string created_at_from = 7;
   */
  createdAtFrom?: string;

  /**
   * @generated from field: optional string created_at_to = 8;
   */
  createdAtTo?: string;

  /**
   * @generated from field: optional string settled_at_from = 9;
   */
  settledAtFrom?: string;

  /**
   * @generated from field: optional string settled_at_to = 10;
   */
  settledAtTo?: string;

  /**
   * @generated from field: optional string sort_by = 11;
   */
  sortBy?: string;

  /**
   * @generated from field: common.SortDirection sort_dir = 12;
   */
  sortDir: SortDirection;

  /**
   * @generated from field: optional common.Pagination pagination = 13;
   */
  pagination?: Pagination;

  /**
   * @generated from field: repeated common.AccountType account_types = 14;
   */
  accountTypes: AccountType[];
};

/**
 * Describes the message client.ListBetsRequest.
 * Use `create(ListBetsRequestSchema)` to create a new message.
 */
export const ListBetsRequestSchema: GenMessage<ListBetsRequest> = /*@__PURE__*/
  messageDesc(file_client_trading, 3);

/**
 * @generated from message client.ListBetsResponse
 */
export type ListBetsResponse = Message<"client.ListBetsResponse"> & {
  /**
   * @generated from field: repeated common.BetMessage data = 1;
   */
  data: BetMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListBetsResponse.
 * Use `create(ListBetsResponseSchema)` to create a new message.
 */
export const ListBetsResponseSchema: GenMessage<ListBetsResponse> = /*@__PURE__*/
  messageDesc(file_client_trading, 4);

/**
 * @generated from message client.CreateBetRequest
 */
export type CreateBetRequest = Message<"client.CreateBetRequest"> & {
  /**
   * @generated from field: string pair_id = 1;
   */
  pairId: string;

  /**
   * @generated from field: common.BetType bet_type = 2;
   */
  betType: BetType;

  /**
   * @generated from field: common.AccountType account_type = 3;
   */
  accountType: AccountType;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: common.BetTimeMode time_mode = 5;
   */
  timeMode: BetTimeMode;

  /**
   * @generated from field: optional int32 duration_seconds = 6;
   */
  durationSeconds?: number;

  /**
   * @generated from field: optional string target_ts = 7;
   */
  targetTs?: string;

  /**
   * @generated from field: optional string entry_price = 8;
   */
  entryPrice?: string;

  /**
   * @generated from field: optional string expected_payout_percent = 9;
   */
  expectedPayoutPercent?: string;
};

/**
 * Describes the message client.CreateBetRequest.
 * Use `create(CreateBetRequestSchema)` to create a new message.
 */
export const CreateBetRequestSchema: GenMessage<CreateBetRequest> = /*@__PURE__*/
  messageDesc(file_client_trading, 5);

/**
 * @generated from message client.GetTradingProfileAnalyticsRequest
 */
export type GetTradingProfileAnalyticsRequest = Message<"client.GetTradingProfileAnalyticsRequest"> & {
  /**
   * @generated from field: client.TradingProfileAccountScope account_scope = 1;
   */
  accountScope: TradingProfileAccountScope;

  /**
   * @generated from field: client.TradingProfilePeriodPreset period_preset = 2;
   */
  periodPreset: TradingProfilePeriodPreset;

  /**
   * @generated from field: optional string date_from = 3;
   */
  dateFrom?: string;

  /**
   * @generated from field: optional string date_to = 4;
   */
  dateTo?: string;

  /**
   * @generated from field: optional string time_zone = 5;
   */
  timeZone?: string;
};

/**
 * Describes the message client.GetTradingProfileAnalyticsRequest.
 * Use `create(GetTradingProfileAnalyticsRequestSchema)` to create a new message.
 */
export const GetTradingProfileAnalyticsRequestSchema: GenMessage<GetTradingProfileAnalyticsRequest> = /*@__PURE__*/
  messageDesc(file_client_trading, 6);

/**
 * @generated from message client.TradingProfileAvailabilityMessage
 */
export type TradingProfileAvailabilityMessage = Message<"client.TradingProfileAvailabilityMessage"> & {
  /**
   * @generated from field: bool has_real_trades = 1;
   */
  hasRealTrades: boolean;

  /**
   * @generated from field: bool has_demo_trades = 2;
   */
  hasDemoTrades: boolean;

  /**
   * @generated from field: bool has_any_trades = 3;
   */
  hasAnyTrades: boolean;

  /**
   * @generated from field: client.TradingProfileAccountScope default_account_scope = 4;
   */
  defaultAccountScope: TradingProfileAccountScope;
};

/**
 * Describes the message client.TradingProfileAvailabilityMessage.
 * Use `create(TradingProfileAvailabilityMessageSchema)` to create a new message.
 */
export const TradingProfileAvailabilityMessageSchema: GenMessage<TradingProfileAvailabilityMessage> = /*@__PURE__*/
  messageDesc(file_client_trading, 7);

/**
 * @generated from message client.TradingProfileKpiMessage
 */
export type TradingProfileKpiMessage = Message<"client.TradingProfileKpiMessage"> & {
  /**
   * @generated from field: int32 trades = 1;
   */
  trades: number;

  /**
   * @generated from field: string profit = 2;
   */
  profit: string;

  /**
   * @generated from field: string win_rate = 3;
   */
  winRate: string;

  /**
   * @generated from field: string trading_volume = 4;
   */
  tradingVolume: string;

  /**
   * @generated from field: int32 current_streak = 5;
   */
  currentStreak: number;

  /**
   * @generated from field: int32 best_streak = 6;
   */
  bestStreak: number;
};

/**
 * Describes the message client.TradingProfileKpiMessage.
 * Use `create(TradingProfileKpiMessageSchema)` to create a new message.
 */
export const TradingProfileKpiMessageSchema: GenMessage<TradingProfileKpiMessage> = /*@__PURE__*/
  messageDesc(file_client_trading, 8);

/**
 * @generated from message client.TradingProfileTrendPointMessage
 */
export type TradingProfileTrendPointMessage = Message<"client.TradingProfileTrendPointMessage"> & {
  /**
   * @generated from field: string bucket_ts = 1;
   */
  bucketTs: string;

  /**
   * @generated from field: string pnl = 2;
   */
  pnl: string;

  /**
   * @generated from field: optional string win_rate = 3;
   */
  winRate?: string;
};

/**
 * Describes the message client.TradingProfileTrendPointMessage.
 * Use `create(TradingProfileTrendPointMessageSchema)` to create a new message.
 */
export const TradingProfileTrendPointMessageSchema: GenMessage<TradingProfileTrendPointMessage> = /*@__PURE__*/
  messageDesc(file_client_trading, 9);

/**
 * @generated from message client.TradingProfileTopPairMessage
 */
export type TradingProfileTopPairMessage = Message<"client.TradingProfileTopPairMessage"> & {
  /**
   * @generated from field: string pair_id = 1;
   */
  pairId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: int32 trade_count = 3;
   */
  tradeCount: number;

  /**
   * @generated from field: string share_percent = 4;
   */
  sharePercent: string;
};

/**
 * Describes the message client.TradingProfileTopPairMessage.
 * Use `create(TradingProfileTopPairMessageSchema)` to create a new message.
 */
export const TradingProfileTopPairMessageSchema: GenMessage<TradingProfileTopPairMessage> = /*@__PURE__*/
  messageDesc(file_client_trading, 10);

/**
 * @generated from message client.TradingProfileInstrumentPnlMessage
 */
export type TradingProfileInstrumentPnlMessage = Message<"client.TradingProfileInstrumentPnlMessage"> & {
  /**
   * @generated from field: string pair_id = 1;
   */
  pairId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: string pnl = 3;
   */
  pnl: string;
};

/**
 * Describes the message client.TradingProfileInstrumentPnlMessage.
 * Use `create(TradingProfileInstrumentPnlMessageSchema)` to create a new message.
 */
export const TradingProfileInstrumentPnlMessageSchema: GenMessage<TradingProfileInstrumentPnlMessage> = /*@__PURE__*/
  messageDesc(file_client_trading, 11);

/**
 * @generated from message client.TradingProfileAnalyticsMessage
 */
export type TradingProfileAnalyticsMessage = Message<"client.TradingProfileAnalyticsMessage"> & {
  /**
   * @generated from field: client.TradingProfileAvailabilityMessage availability = 1;
   */
  availability?: TradingProfileAvailabilityMessage;

  /**
   * @generated from field: client.TradingProfileAccountScope selected_account_scope = 2;
   */
  selectedAccountScope: TradingProfileAccountScope;

  /**
   * @generated from field: string range_start = 3;
   */
  rangeStart: string;

  /**
   * @generated from field: string range_end = 4;
   */
  rangeEnd: string;

  /**
   * @generated from field: client.TradingProfileKpiMessage kpi = 5;
   */
  kpi?: TradingProfileKpiMessage;

  /**
   * @generated from field: repeated client.TradingProfileTrendPointMessage pnl_trend = 6;
   */
  pnlTrend: TradingProfileTrendPointMessage[];

  /**
   * @generated from field: repeated client.TradingProfileTrendPointMessage win_rate_trend = 7;
   */
  winRateTrend: TradingProfileTrendPointMessage[];

  /**
   * @generated from field: repeated client.TradingProfileTopPairMessage top_pairs = 8;
   */
  topPairs: TradingProfileTopPairMessage[];

  /**
   * @generated from field: repeated client.TradingProfileInstrumentPnlMessage instrument_pnl = 9;
   */
  instrumentPnl: TradingProfileInstrumentPnlMessage[];

  /**
   * @generated from field: bool is_empty_for_selected_period = 10;
   */
  isEmptyForSelectedPeriod: boolean;
};

/**
 * Describes the message client.TradingProfileAnalyticsMessage.
 * Use `create(TradingProfileAnalyticsMessageSchema)` to create a new message.
 */
export const TradingProfileAnalyticsMessageSchema: GenMessage<TradingProfileAnalyticsMessage> = /*@__PURE__*/
  messageDesc(file_client_trading, 12);

/**
 * @generated from enum client.TradingProfileAccountScope
 */
export enum TradingProfileAccountScope {
  /**
   * @generated from enum value: TRADING_PROFILE_ACCOUNT_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRADING_PROFILE_ACCOUNT_SCOPE_REAL = 1;
   */
  REAL = 1,

  /**
   * @generated from enum value: TRADING_PROFILE_ACCOUNT_SCOPE_DEMO = 2;
   */
  DEMO = 2,
}

/**
 * Describes the enum client.TradingProfileAccountScope.
 */
export const TradingProfileAccountScopeSchema: GenEnum<TradingProfileAccountScope> = /*@__PURE__*/
  enumDesc(file_client_trading, 0);

/**
 * @generated from enum client.TradingProfilePeriodPreset
 */
export enum TradingProfilePeriodPreset {
  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_WEEK = 2;
   */
  WEEK = 2,

  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_MONTH = 3;
   */
  MONTH = 3,

  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_YEAR = 4;
   */
  YEAR = 4,

  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_ALL_TIME = 5;
   */
  ALL_TIME = 5,

  /**
   * @generated from enum value: TRADING_PROFILE_PERIOD_PRESET_CUSTOM = 6;
   */
  CUSTOM = 6,
}

/**
 * Describes the enum client.TradingProfilePeriodPreset.
 */
export const TradingProfilePeriodPresetSchema: GenEnum<TradingProfilePeriodPreset> = /*@__PURE__*/
  enumDesc(file_client_trading, 1);

/**
 * @generated from service client.TradingRPCService
 */
export const TradingRPCService: GenService<{
  /**
   * @generated from rpc client.TradingRPCService.ListTradingPairs
   */
  listTradingPairs: {
    methodKind: "unary";
    input: typeof ListTradingPairsRequestSchema;
    output: typeof ListTradingPairsResponseSchema;
  },
  /**
   * @generated from rpc client.TradingRPCService.ListBets
   */
  listBets: {
    methodKind: "unary";
    input: typeof ListBetsRequestSchema;
    output: typeof ListBetsResponseSchema;
  },
  /**
   * @generated from rpc client.TradingRPCService.CreateBet
   */
  createBet: {
    methodKind: "unary";
    input: typeof CreateBetRequestSchema;
    output: typeof BetMessageSchema;
  },
  /**
   * @generated from rpc client.TradingRPCService.GetBetStats
   */
  getBetStats: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof BetStatsMessageSchema;
  },
  /**
   * @generated from rpc client.TradingRPCService.GetTradingProfileAnalytics
   */
  getTradingProfileAnalytics: {
    methodKind: "unary";
    input: typeof GetTradingProfileAnalyticsRequestSchema;
    output: typeof TradingProfileAnalyticsMessageSchema;
  },
  /**
   * @generated from rpc client.TradingRPCService.CancelBet
   */
  cancelBet: {
    methodKind: "unary";
    input: typeof CancelBetRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_client_trading, 0);

